export default __webpack_public_path__ + "static/stakingbg-fb2cdb614a2e605952e0c27576f1e026.png";